<div class="complex-value-container">
  <table>
    <tr class="sub-item" *ngFor="let item of complexAttributeValue.items">
      <td class="sub-title">{{ item.name }}:</td>
      <td class="sub-value">
        <ng-container *ngIf="item.isLongAnswerType">
          <div class="attribute-long-answer" [innerHTML]="item.value | safeHtml"></div>
        </ng-container>
        <ng-container *ngIf="item.isSkillType">
          <skill [selectedSkillLevel]="item.subFieldValues[0]?.attributeDefinitionValueListItem"></skill>
        </ng-container>
        <ng-container *ngIf="item.isStarRatingType">
          <app-star-rating-attribute
            [selectedStarRating]="item.subFieldValues[0]?.attributeDefinitionValueListItem"
          ></app-star-rating-attribute>
        </ng-container>
        <ng-container *ngIf="!item.isSkillType && !item.isStarRatingType && !item.isLongAnswerType">
          <ng-container *ngIf="item.allowsMultiple">
            <p *ngFor="let value of item.values" class="attribute-value">{{ value }}</p>
          </ng-container>
          <ng-container *ngIf="!item.allowsMultiple">
            <p class="attribute-value">{{ item.value }}</p>
          </ng-container>
        </ng-container>
      </td>
    </tr>
  </table>
</div>
